module.exports = __webpack_public_path__ + "img/ecoase_2025.54c5b5f6.png";